<script setup lang="ts">
import { computed, ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { Roles } from '@/constants.ts'
import eventsHttpService from '@/services/http/eventsHttpService.ts'
import EventResultsPanel from '@/components/events/EventResultsPanel.vue'
import EventSelect from '@/components/events/EventSelect.vue'

definePage({
  meta: {
    allowedRoles: [Roles.Admin, Roles.Manager],
  },
})

const { t, locale } = useI18n()

// Выбор мероприятия сверху — единый EventSelect (дефолт по featured-событию).
const eventId = ref<string | null>(null)

// Статус публикации результатов берётся из карточки события (Event.ResultsPublishedAt) —
// панель управляет публикацией и по её изменению эмитит `published`, тогда карточку перезапрашиваем.
const detailQuery = useQuery({
  queryKey: computed(() => ['admin', 'events', 'detail', eventId.value, locale.value]),
  queryFn: () => eventsHttpService.getEventDetail(eventId.value!),
  enabled: computed(() => !!eventId.value),
})
</script>

<template>
  <section class="flex flex-col gap-4 w-full">
    <!-- Шапка: заголовок слева, выбор мероприятия справа -->
    <div class="flex flex-wrap items-center justify-between gap-3 w-full">
      <h1 class="text-xl font-bold">{{ t('nav.results') }}</h1>
      <EventSelect v-model="eventId" data-test="results-event-select" />
    </div>

    <div v-if="eventId && detailQuery.isLoading.value" class="flex justify-center py-8">
      <ProgressSpinner style="width: 2rem; height: 2rem" stroke-width="4" />
    </div>
    <EventResultsPanel
      v-else-if="eventId && detailQuery.data.value"
      :event-id="eventId"
      :results-published-at="detailQuery.data.value.resultsPublishedAt"
      @published="detailQuery.refetch()"
    />
    <div v-else class="text-sm text-surface-500">{{ t('events.selectEvent') }}</div>
  </section>
</template>
